/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/subverted/"

const SUBVERTED: CommunityData = {
  code: "subverted",
  inviteCode: "subverted",
  name: "SUBVERTED",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sub-020`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      logo: {
        src: "https://media.werz.at/community/icon/cmmluo4wv00009kbunv15czf9.jpg?uploadTime=1773348481604&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[208px] h-[20px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#444444]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['SUBVERTEDCOPYRegular']",
      primaryButton:
        "bg-[#ffffff] border border-[#ffffff] px-[18px] pt-[14px] py-[18px] !text-[#000000] font-['SUBVERTEDHEADLINEBold'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#444444]",
      separator: "border-[#444444]",
      item: "font-['SUBVERTEDHEADLINEBold'] text-[14px] text-[#ffffff] text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#444444] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#444444] !pb-8",
      titles: "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[26px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#bdbdbd] font-['SUBVERTEDCOPYRegular'] text-[14px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[26px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[16px] text-left leading-[100%]",
          subtitle:
            "text-[#bdbdbd] font-['SUBVERTEDCOPYRegular'] text-[14px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[26px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[16px] text-left leading-[100%]",
          subtitle:
            "text-[#bdbdbd] font-['SUBVERTEDCOPYRegular'] text-[12px] text-left leading-[130%] mt-2",
          location:
            "text-[#bdbdbd] font-['SUBVERTEDCOPYRegular'] text-[12px] text-left leading-[130%] mt-1",
          date: "text-[#bdbdbd] font-['SUBVERTEDCOPYRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[22px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[26px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `${S3_PREFIX}web-background.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#000000]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[140px] h-[14px] sm:w-[208px] sm:h-[20px] invert",
      },
      werzLogoColor: "#ffffff",
      title: "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[28px] leading-[120%]",
      text: "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[120%]",
      button:
        "bg-[#ffffff] border border-[#ffffff] p-4 pt-3 cursor-pointer w-fit text-[#000000] font-['SUBVERTEDHEADLINEBold'] text-[16px] leading-[100%]",
      input: {
        base: "font-['SUBVERTEDCOPYRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#000000] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['SUBVERTEDCOPYRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "text-[#8D8D8D] font-['SUBVERTEDCOPYRegular'] text-[14px] leading-[120%]",
      skipButton:
        "text-[#8D8D8D] font-['SUBVERTEDCOPYRegular'] text-[14px] leading-[120%] cursor-pointer",
      modal: {
        container: "bg-[#111111] px-[40px] py-[48px]",
        title:
          "font-['SUBVERTEDHEADLINEBold'] text-[24px] leading-[120%] text-[#ffffff] text-center",
        text: "text-[#8D8D8D] font-['SUBVERTEDCOPYRegular'] text-[14px] leading-[120%] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[120%] text-center text-[#ffffff] bg-[#000000]",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/subverted/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/subverted/web-background-non-member.jpg",
      bgColor: "#000000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#444444]",
        name: "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[26px] text-center text-center mt-4 mb-1",
        location: "font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-center text-center mb-2",
        description:
          "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#333333] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#444444]",
          title: "font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left text-center mb-1",
          text: "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center text-center",
          button:
            "bg-[#333333] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          duration: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
          name: "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#ffffff",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#444444]",
          name: "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] border border-[#444444] text-[#000000] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-center",
          duration: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
          location: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
          button:
            "bg-[#333333] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#444444]",
            name: "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[14px] text-left",
            link: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[14px] text-left",
            status:
              "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] leading-[100%] text-[14px] text-left",
            button:
              "bg-[#333333] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          name: "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#ffffff",
          created: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        seeAllNews:
          "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          coverUrl: "overflow-hidden m-2 border border-[#444444]",
          duration: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
          liveType: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#ffffff] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#000000",
          start: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
          title:
            "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#444444] text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#444444]",
          name: "text-[#ffffff] font-['SUBVERTEDHEADLINE_Bold'] text-[16px] text-left",
          triangleIconColor: "#ffffff",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#444444]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#bdbdbd] font-['SUBVERTEDCOPY_Regular'] text-[12px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#444444] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#444444]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[26px] text-left leading-[100%]",
        subtitle:
          "text-[#bdbdbd] font-['SUBVERTEDCOPYRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#ffffff] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['SUBVERTEDHEADLINEBold'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[130%] text-[#bdbdbd]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[22px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[22px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#444444] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[22px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['SUBVERTEDCOPYRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[22px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#333333] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#444444] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[16px] text-left leading-[100%] mb-1",
          description:
            "text-[#bdbdbd] font-['SUBVERTEDCOPYRegular'] text-[14px] text-left leading-[130%] mb-1 flex flex-row",
          price:
            "text-[#bdbdbd] font-['SUBVERTEDHEADLINEBold'] text-[16px] text-left leading-[100%]",
          quantity:
            "text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#bdbdbd] font-['SUBVERTEDHEADLINEBold'] text-[16px] text-left leading-[100%]",
          counterContainer:
            "bg-[#333333] border border-[#ffffff] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#333333] border border-[#ffffff] px-[12px] py-[12px] text-[#ffffff] font-['SUBVERTEDHEADLINEBold'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default SUBVERTED
